import { z } from 'zod';
import type { CustomerGroupToken } from '@sleed/bizcommerce-api';

/**
 * Customer group edit form. Mirrors `CustomerGroupToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Customers/CustomerGroups/index.js): cd required ≤50, nm required ≤50,
 * dsc optional ≤500. The dynamic membership criteria (ExpressionId) are edited separately via the
 * criteria builder. iv/si/erpcd are carried through unchanged so an edit never wipes them.
 */
export const customerGroupSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	nm: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	dsc: z.string().trim().max(500, 'validation.tooLong').nullable(),
	iv: z.boolean().optional(),
	si: z.number().optional(),
	erpcd: z.string().nullable().optional()
});

export type CustomerGroupFormValues = z.infer<typeof customerGroupSchema>;

export const EMPTY_CUSTOMER_GROUP: CustomerGroupFormValues = {
	cd: '',
	nm: '',
	dsc: '',
	iv: true,
	si: 0,
	erpcd: null
};

export function tokenToForm(token: CustomerGroupToken): CustomerGroupFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		nm: token.nm ?? '',
		dsc: token.dsc ?? '',
		iv: token.iv ?? true,
		si: token.si ?? 0,
		erpcd: token.erpcd ?? null
	};
}

export function formToToken(form: CustomerGroupFormValues): CustomerGroupToken {
	return {
		id: form.id,
		cd: form.cd.trim(),
		nm: form.nm.trim(),
		dsc: form.dsc?.trim() || null,
		iv: form.iv ?? true,
		si: form.si ?? 0,
		erpcd: form.erpcd ?? null
	};
}
